import React, { useEffect } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { HealthcareTransitionViewProps } from './models';
import { useTranslation } from '@sunbit-dev/translations';
import { useTrack } from '~/hooks/track';
import { EventsNames } from '~/enums/Events';
import { PagesTestIds } from '~/enums/TestIds';
import sunbitLogo from '~/assets/sunbit-blue-logo.svg';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import { Slogan } from '~/components/app/components/landingPage/components/slogan/Slogan';
import { formatCurrency } from '@sunbit-dev/common/helpers/money';

export const HealthcareTransitionView = styled(({ className, amountRequested }: HealthcareTransitionViewProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'healthcare_transition_view' });
  const { track } = useTrack();

  useEffect(() => {
    track({ eventName: EventsNames.expiredLink, type: TrackCategory.View });
  }, []);

  return (
    <div className={className} data-testid={PagesTestIds.HealthcareTransitionView}>
      <img className="sunbit-logo" src={sunbitLogo} alt={t('sunbit_signature')} />
      <div className="info">
        <h1 className="total-amount-title">
          {t('total_amount')}
          <span className="amount">
            {formatCurrency({
              value: amountRequested.toString(),
              showFullDecimalNumber: true,
            })}
            *
          </span>
        </h1>
        <p className="down-payment-notice">{t('down_payment_notice')}</p>
      </div>
      <Slogan className="slogan" />
    </div>
  );
})`
  ${styles.HealthcareTransitionView}
`;
